// Central place for status metadata so App.jsx, AdminPage.jsx, and card
// components all agree on labels, tab ids, and status values.

export const STATUSES = {
  REQUESTED: "Requested",   // Freshly submitted, not yet triaged
  PLANNED: "Planned",       // Admin has accepted it for future implementation ("Open" tab)
  IN_PROGRESS: "In Progress",
  IN_BETA: "In Beta",
  RELEASED: "Released",
  CLOSED: "Closed",
};

// Tabs shown on both the public roadmap and the admin panel.
export const STATUS_TABS = [
  { id: "all", label: "All", statuses: null },
  { id: "not_started", label: "Requested", statuses: [STATUSES.REQUESTED] },
  { id: "open", label: "Planned", statuses: [STATUSES.PLANNED] },
  { id: "in_progress", label: "In Progress", statuses: [STATUSES.IN_PROGRESS] },
  { id: "in_beta", label: "In Beta", statuses: [STATUSES.IN_BETA] },
  { id: "released", label: "Released", statuses: [STATUSES.RELEASED] },
  { id: "closed", label: "Closed", statuses: [STATUSES.CLOSED] },
];

// Display label for a tab id. Prefer this over massaging the raw id in the UI:
// "not_started" is labelled "Requested", so `id.replace("_", " ")` would print
// the wrong word.
export const getTabLabel = (tabId) =>
  STATUS_TABS.find((t) => t.id === tabId)?.label || tabId;

export const statusMatchesTab = (status, tabId) => {
  const tab = STATUS_TABS.find((t) => t.id === tabId);
  if (!tab || !tab.statuses) return true; // "all"
  return tab.statuses.includes(status);
};

export const statusStyle = {
  [STATUSES.REQUESTED]:   { bg: "rgba(255,255,255,0.06)",  border: "rgba(255,255,255,0.12)", text: "#a1a1aa", label: "Requested" },
  [STATUSES.PLANNED]:     { bg: "rgba(56,189,248,0.12)",   border: "rgba(56,189,248,0.25)",  text: "#7dd3fc", label: "Planned" },
  [STATUSES.IN_PROGRESS]: { bg: "rgba(234,179,8,0.12)",    border: "rgba(234,179,8,0.25)",   text: "#fde047", label: "In Progress" },
  [STATUSES.IN_BETA]:     { bg: "rgba(99,102,241,0.15)",   border: "rgba(99,102,241,0.30)",  text: "#a5b4fc", label: "In Beta" },
  [STATUSES.RELEASED]:    { bg: "rgba(34,197,94,0.12)",    border: "rgba(34,197,94,0.25)",   text: "#86efac", label: "Released" },
  [STATUSES.CLOSED]:      { bg: "rgba(239,68,68,0.10)",    border: "rgba(239,68,68,0.25)",   text: "#fca5a5", label: "Closed" },
};

export const getStatusStyle = (status) => statusStyle[status] || statusStyle[STATUSES.REQUESTED];
